import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck, ArrowRight } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-20 md:py-32 bg-white relative overflow-hidden" data-id="element-169">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-170">
        <div className="absolute top-10 left-10 w-64 h-64 bg-[#E8F0E6] rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-171"></div>
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-[#FAF8F5] rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-172"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-173">
        <div className="max-w-3xl mx-auto text-center" data-id="element-174">
          <h2 className="text-3xl md:text-5xl font-bold text-[#44403C] mb-6" data-id="element-175">
            Imagina esto en 2 semanas
          </h2>
          <p className="text-xl text-[#57534E] mb-12 leading-relaxed" data-id="element-176">
            No "una casa perfecta". Sino una casa donde sientes que{' '}
            <strong data-id="element-177">no estás empeorando las cosas sin querer</strong>. Donde por
            fin tienes una rutina que no depende de tu motivación.
          </p>

          <div className="bg-white rounded-3xl shadow-xl border border-[#EBE5DE] p-8 md:p-12 max-w-lg mx-auto transform hover:scale-105 transition-transform duration-300" data-id="element-178">
            <div className="inline-block px-4 py-1 bg-[#FAF8F5] text-[#C97D60] font-bold rounded-full text-sm mb-6" data-id="element-179">
              OFERTA ESPECIAL
            </div>

            <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-180">
              <span className="text-5xl font-bold text-[#44403C]" data-id="element-181">$9.50</span>
            </div>
            <p className="text-[#78716C] mb-8 text-sm" data-id="element-182">
              Pago único • Acceso inmediato
            </p>

            <ul className="text-left space-y-4 mb-8 border-t border-b border-[#F5F1EB] py-6" data-id="element-183">
              <li className="flex items-center gap-3 text-[#57534E]" data-id="element-184">
                <ShieldCheck className="w-5 h-5 text-[#8B9D83]" data-id="element-185" />
                <span data-id="element-186">Ebook Completo (PDF)</span>
              </li>
              <li className="flex items-center gap-3 text-[#57534E]" data-id="element-187">
                <ShieldCheck className="w-5 h-5 text-[#8B9D83]" data-id="element-188" />
                <span data-id="element-189">Lista de compras Rutina Low-Tox</span>
              </li>
              <li className="flex items-center gap-3 text-[#57534E]" data-id="element-190">
                <ShieldCheck className="w-5 h-5 text-[#8B9D83]" data-id="element-191" />
                <span data-id="element-192">Guía de Brotes 48h</span>
              </li>
            </ul>

            <Button fullWidth size="lg" className="mb-4 group" data-id="element-193">
              Comprar Ahora
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-194" />
            </Button>

            <p className="text-xs text-[#78716C]" data-id="element-195">
              Una compra pequeña comparada con el gasto silencioso de probar
              productos al azar.
            </p>
          </div>

          <div className="mt-12 flex flex-col items-center gap-4" data-id="element-196">
            <div className="flex -space-x-2" data-id="element-197">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-10 h-10 rounded-full bg-[#E8F0E6] border-2 border-white flex items-center justify-center text-xs font-bold text-[#6B8E6B]" data-id="element-198">
                  {String.fromCharCode(64 + i)}
                </div>)}
            </div>
            <p className="text-sm text-[#57534E]" data-id="element-199">
              Únete a cientos de mamás que ya recuperaron la paz en su hogar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}